import classnames from "classnames";
import { dateFormat } from "neetocommons/utils";
import { Typography } from "neetoui";

import { ACTIONS, AUDIT_ICON_MAP, INTEGRATION_ICON_MAP } from "./constants";
import { constructAuditLogText, transformAction } from "./utils";

const Card = ({
  auditLog,
  countriesMap,
  index,
  permissionsMap,
  totalCount,
}) => {
  const { key, metadata, performer, updatedAt } = auditLog;

  const action = transformAction(key);
  const performedBy = performer?.name || "";
  const performedAt = dateFormat.dateTime(updatedAt);

  const auditText = constructAuditLogText({
    countriesMap,
    action,
    performedBy,
    permissionsMap,
    ...metadata,
  });

  const isIntegrationAction =
    action === ACTIONS.INTEGRATION_CONNECTED ||
    action === ACTIONS.INTEGRATION_DISCONNECTED ||
    action === ACTIONS.INTEGRATION_DISCONNECTED_BY_PROVIDER;

  const Icon = isIntegrationAction
    ? INTEGRATION_ICON_MAP[metadata?.integrationName] || AUDIT_ICON_MAP[action]
    : AUDIT_ICON_MAP[action];

  return (
    <div
      data-testid="audit-log-card"
      className={classnames(
        "align-items-center neeto-ui-border-gray-200 flex w-full gap-x-4 border-b border-l border-r p-3",
        {
          "rounded-t-md border-t": index === 0,
          "rounded-b-md": index === totalCount - 1,
        }
      )}
    >
      <div className="neeto-ui-rounded-full neeto-ui-bg-gray-100 flex size-10 flex-shrink-0 items-center justify-center">
        <Icon className="neeto-ui-text-gray-600 flex-shrink-0" size={22} />
      </div>
      <div className="flex flex-col gap-y-2" data-testid="audit-log-content">
        <Typography
          component="span"
          data-testid="audit-log-text"
          lineHeight="normal"
          style="body2"
        >
          {auditText}
        </Typography>
        <Typography
          className="neeto-ui-text-gray-500 m-0"
          data-testid="audit-log-timestamp"
          style="body3"
        >
          {performedAt}
        </Typography>
      </div>
    </div>
  );
};

export default Card;
